import service from '@/store/services/employers/staffs-service';

const state = {
    list: {},
    staff: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, staff) => {
        state.staff = staff;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(staff => {
                commit('SET_RESOURCE', staff);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(staff => {
                commit('SET_RESOURCE', staff);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((staff) => {
                commit('SET_RESOURCE', staff);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((staff) => {
                commit('SET_RESOURCE', staff);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    upload ({ commit, dispatch }, { item }) {
        return service.upload(item)
            .then((url) => {
                commit('SET_URL', url);
            });
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    staff: state => state.staff,
    url: state => state.url,
    dropdown: (state) => {
        return state.list.map(staff => ({
            id: staff.id,
            name: staff.name,
            description: staff.description,
            address: staff.address,
            phone_number: staff.phone_number,
            telephone_number: staff.telephone_number,
            email:staff.email,
            website: staff.website,
            logo: staff.logo,
            business_name: staff.business_name,
        }));
    }
};

const staffs = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default staffs;
